class Layout {
    static loadingMap = false;
    static requestedTiny = false;
    static requestedXlx = false;
    static requestedHightcharts = {highcharts: false, modules: {}};
    static svgIA = `<div class="ia-icon"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 81.07 81.07">
    <path class="cls-1"
          d="M47.78,53.23l-14.56-5.38-5.38-14.56h0c-.46-1.23-1.62-2.04-2.93-2.04s-2.48.81-2.93,2.04l-5.39,14.56-14.56,5.38c-1.22.46-2.04,1.62-2.04,2.93s.81,2.48,2.04,2.93l14.56,5.39,5.39,14.56c.45,1.22,1.62,2.04,2.93,2.04s2.47-.81,2.93-2.04l5.38-14.56,14.56-5.39h0c1.22-.45,2.04-1.62,2.04-2.93s-.81-2.47-2.04-2.93h0ZM29.71,59.12h0c-.86.32-1.53.99-1.84,1.85l-2.96,7.98-2.96-7.98h0c-.32-.86-.99-1.53-1.85-1.85l-7.98-2.96,7.98-2.96h0c.86-.31,1.53-.98,1.85-1.84l2.96-7.98,2.96,7.98h0c.31.86.99,1.53,1.84,1.84l7.98,2.96-7.98,2.95Z"/>
    <path class="cls-1"
          d="M79.03,40.73l-12.27-4.54-4.54-12.27h0c-.46-1.23-1.62-2.04-2.93-2.04s-2.48.81-2.93,2.04l-4.54,12.27-12.27,4.54h0c-1.22.46-2.04,1.63-2.04,2.93s.81,2.48,2.04,2.93l12.27,4.54,4.54,12.27h0c.45,1.23,1.62,2.04,2.93,2.04s2.47-.81,2.93-2.04l4.54-12.27,12.27-4.54h0c1.22-.46,2.04-1.63,2.04-2.93s-.81-2.47-2.04-2.93ZM63.24,45.77h0c-.86.32-1.53.99-1.85,1.85l-2.11,5.7-2.11-5.7c-.32-.86-.99-1.53-1.84-1.84l-5.7-2.11,5.7-2.11c.86-.32,1.53-.99,1.84-1.85l2.11-5.7,2.11,5.7c.32.86.99,1.53,1.85,1.85l5.7,2.11-5.7,2.11Z"/>
    <path class="cls-1"
          d="M20.78,21.59l10,3.7,3.7,10c.46,1.23,1.62,2.04,2.93,2.04s2.48-.81,2.93-2.04l3.7-10,10-3.7h0c1.22-.45,2.04-1.62,2.04-2.93s-.81-2.47-2.04-2.93l-10-3.7-3.7-10h0c-.45-1.23-1.62-2.04-2.93-2.04s-2.47.81-2.93,2.04l-3.7,10-10,3.7c-1.22.46-2.04,1.62-2.04,2.93s.81,2.48,2.04,2.93ZM34.29,17.4h0c.86-.31,1.53-.98,1.85-1.84l1.27-3.44,1.27,3.42h0c.31.86.99,1.53,1.84,1.84l3.42,1.27-3.44,1.27h0c-.86.31-1.53.99-1.84,1.84l-1.27,3.42-1.27-3.44c-.31-.86-.99-1.53-1.84-1.84l-3.44-1.27,3.45-1.24Z"/>
</svg></div>`;

    static resizeCharts() {
        if (window.resizeCharts) {
            timeout(() => {
                for (let chart of window.resizeCharts) {
                    chart.resize();
                }
            }, 500, 'resizeCharts');
        }

    }

    static getSkeletonLoading(dark = false, width = '48%') {
        return `<div class="form-loader skeleton-loading-container ${dark ? 'dark' : ''} mt-10" style="width: {width: }">
                <div class="skeleton-loading" style="width: 100%;">
                    <div></div>
                </div>
                <div class="skeleton-loading" style="width: 83%;">
                    <div></div>
                </div>
                <div class="skeleton-loading" style="width: 46%;">
                    <div></div>
                </div>
                <div class="skeleton-loading" style="width: 66%;">
                    <div></div>
                </div>
            </div>`;
    }

    static getEditorLang() {
        switch (ISO_LOCALE) {
            case 'en-US' :
                return 'en';
            default:
                return ISO_LOCALE.replace('-', '_');
        }
    }

    static async loadEditor(elId, options) {
        options = extend({
            selector: '#' + elId,
            statusbar: false,
            language: Layout.getEditorLang(),
            automatic_uploads: true,
            //file_picker_types: 'image',
            images_file_types: 'jpg,jpeg,gif,png,webp',
            plugins: [
                'lists', 'table', 'link', 'autoresize'
            ],
            content_css:
                "/vendor/tinymce" + (Layout.darkMode ? '_dark' : '') + "_custom.css?v=" + APP_FINGERPRINT,
            menubar: false,
            skin: Layout.darkMode ? "oxide-dark" : 'oxide',
            destroyOnLeave: true,
            powerpaste_allow_local_images: true,
            powerpaste_word_import: 'prompt',
            powerpaste_googledocs_imports: 'prompt',
            powerpaste_html_import: 'prompt',
            document_base_url: window.location.origin + '/',
            urlconverter_callback: (url, node, on_save, name) => {
                if (url.startsWith('data:image') || url.startsWith('blob:'))
                    return url;
                // Do some custom URL conversion
                url = url.replace(BASE_URL, '')
                    .replace(window.location.origin, '');
                return url.ltrim('/');
            },
            file_picker_callback: function (cb, value, meta) {
                let input = document.createElement('input');
                input.setAttribute('type', 'file');

                const accept = [];
                for (let ext of Layout.acceptExtensions) {
                    accept.push('.' + ext);
                }

                input.setAttribute('accept', accept.join(','));
                input.onchange = async function () {
                    let file = this.files[0];

                    let formData = new FormData();
                    formData.append('Filedata', file, file.name);
                    formData.append('location', '/assets');

                    Layout.blockUI();
                    try {
                        let response = await Http.post('/upload/file', formData)
                        if (response.data && response.data.status) {
                            cb(response.data.data.cloud_full_path, {title: file.name});
                        } else {
                            console.error(response.data.message);
                        }
                    } catch (e) {
                        console.error(e.message);
                    }
                    Layout.unblockUI();
                };
                input.click();
            },
            images_upload_handler: async function (blobInfo, success, failure, progress) {
                let formData = new FormData();
                formData.append('Filedata', blobInfo.blob(), blobInfo.filename());
                formData.append('location', '/images');

                try {
                    let response = await Http.post('/upload/image', formData, {
                        onUploadProgress: function (progressEvent) {
                            let percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
                            //progress(percentCompleted);
                        }
                    })
                    if (response.data && response.data.status) {
                        success(response.data.data.cloud_full_path);
                    } else {
                        failure(response.data.message);
                    }
                } catch (e) {
                    failure(e.message);
                }
            },
            toolbar: 'bold italic underline strikethrough | fontsizeselect forecolor backcolor removeformat | link image | alignleft aligncenter alignright alignjustify | outdent indent | numlist bullist | table',
            height: 300,
            toolbar_sticky: true
        }, options);

        /*if (options.plugins.indexOf('image') !== -1) {
            options.paste_block_drop = true;
        }*/

        const callback = async function () {
            tinymce.remove('#' + elId);
            if (options.destroyOnLeave) {
                Layout.onBeforeLeave.push(function () {
                    try {
                        tinymce.remove('#' + elId);
                    } catch (e) {
                    }
                });
            }
            if ($("#" + elId).is(':visible')) {
                return await tinymce.init(options);
            }
            return await (new Promise(resolve => {
                onVisible(document.getElementById(elId), function () {
                    resolve(tinymce.init(options));
                });
            }));
        }
        return new Promise(resolve => {
            if (typeof tinymce !== 'object') {
                if (!Layout.requestedTiny) {
                    Layout.requestedTiny = true;
                    AssetLoader.addScript("/vendor/tinymce/tinymce.min.js?v=" + APP_FINGERPRINT, false, true);
                }
                let tinyMceInterval = setInterval(() => {
                    if (typeof tinymce === 'object') {
                        clearInterval(tinyMceInterval);

                        resolve(callback());
                    }
                }, 50);

            } else {
                resolve(callback());
            }
        });
    }

    static async loadXlsx() {
        return new Promise(resolve => {
            if (typeof XLSX !== 'object') {
                if (!Layout.requestedXlx) {
                    Layout.requestedXlx = true;
                    AssetLoader.addScript("/vendor/xlsx/xlsx.mini.min.js?v=" + APP_FINGERPRINT, false, true);
                }
                let objectInterval = setInterval(() => {
                    if (typeof XLSX === 'object') {
                        clearInterval(objectInterval);
                        resolve(true);
                    }
                }, 50);

            } else {
                resolve(true);
            }
        });
    }

    static async requestHighCharts(modules = []) {
        return new Promise(resolve => {
            if (typeof Highcharts !== 'object') {
                if (!Layout.requestedHightcharts.highcharts) {
                    Layout.requestedHightcharts.highcharts = true;
                    AssetLoader.addScript("/vendor/highcharts/highcharts.js?v=" + APP_FINGERPRINT, false, true);
                }
                let HighchartsInterval = setInterval(() => {
                    if (typeof Highcharts === 'object') {

                        let allExists = true;
                        for (let module of modules) {
                            if (!Layout.requestedHightcharts.modules[module]) {
                                AssetLoader.addScript("/vendor/highcharts/modules/" + module + ".js?v=" + APP_FINGERPRINT, false, true);
                                Layout.requestedHightcharts.modules[module] = true;
                            }
                            if (!Highcharts._modules['masters/modules/' + module + '.src.js']) {
                                allExists = false;
                            }
                        }
                        if (allExists) {
                            clearInterval(HighchartsInterval);
                            resolve(true);
                        }
                    }
                }, 50);

            } else {
                let allExists = true;
                for (let module of modules) {
                    if (!Layout.requestedHightcharts.modules[module]) {
                        AssetLoader.addScript("/vendor/highcharts/modules/" + module + ".js?v=" + APP_FINGERPRINT, false, true);
                        Layout.requestedHightcharts.modules[module] = true;
                    }
                    if (!Highcharts._modules['masters/modules/' + module + '.src.js']) {
                        allExists = false;
                    }
                }
                if (!allExists) {

                    let HighchartsInterval = setInterval(() => {
                        let allExists = true;
                        for (let module of modules) {
                            if (!Highcharts._modules['masters/modules/' + module + '.src.js']) {
                                allExists = false;
                            }
                        }
                        if (allExists) {
                            clearInterval(HighchartsInterval);
                            resolve(true);
                        }
                    }, 50);
                } else {
                    resolve(true);
                }
            }
        });
    }

    static async loadMap() {
        return new Promise(resolve => {
            if (!Layout.loadingMap && (typeof google !== 'object' || typeof google.maps !== 'object')) {
                Layout.loadingMap = true;
                AssetLoader.addScript('https://maps.googleapis.com/maps/api/js?key=' + GMAP_KEY + '&libraries=places&language=' + LOCALE, false, true);
            }
            let interVal = setInterval(() => {
                if (typeof google === 'object' && typeof google.maps === 'object') {

                    window.MarkerWithLabel = loadGmapsMarkerWithLabel();

                    clearInterval(interVal);
                    resolve(true);
                }
            }, 100);

        });
    }

    static addHook(name, callback) {
        if (!Layout.hooks[name]) {
            Layout.hooks[name] = [];
        }
        Layout.hooks[name].push(callback);
    }

    static clearHooks() {
        Layout.hooks = {};
    }
    static clearHook(name) {
        Layout.hooks[name] = [];
    }

    static runHooks(name, ...args) {
        if (Layout.hooks[name]) {
            for (let callback of Layout.hooks[name]) {
                try {
                    callback(...args);
                } catch (e) {
                    console.error(`Error running hook ${name}:`, e);
                }
            }
            //Layout.hooks[name] = [];
        }
    }

    static hasHook(name) {
        return Layout.hooks[name] && Layout.hooks[name].length > 0;
    }

    static runHook(name, output = null, ...args) {
        if (Layout.hooks[name]) {
            const callback = Layout.hooks[name][0];
            //Layout.hooks[name] = [];
            try {
                return callback(output, ...args);
            } catch (e) {
                console.error(`Error running hook ${name}:`, e);
            }
        }
        return output;
    }

    static init() {
        //M.AutoInit();
        Layout.token = $('meta[name="csrf-token"]').attr('content');

        // hack de bug de focus do jquery
        $(document).on('select2:open', () => {
            document.querySelector('.select2-container--open .select2-search__field').focus();
        });
        Layout.onBeforeLeave = [];
        Layout.onAfterLeave = [];
        Layout.hooks = {};
        Layout.flags = {};
        Layout.evalQueue = [];
        Layout.canChangeTitle = true;
        Layout.darkMode = window.darkMode;
        Layout.firstEval = true;
        Layout.showingMenu = false;
        Layout.select2_open_element = null;

        Layout.acceptExtensions = [
            'avi',
            'csv',
            'doc',
            'docx',
            'eml',
            'gif',
            'htm',
            'html',
            'jpeg',
            'jpg',
            'log',
            'mkv',
            'mov',
            'mp3',
            'mp4',
            'msg',
            'odt',
            'pdf',
            'png',
            'ppt',
            'pptx',
            'rar',
            'rtf',
            'svg',
            'ttf',
            'txt',
            'wav',
            'webp',
            'xls',
            'xlsb',
            'xlsm',
            'xlsx',
            'xml',
            'zip',
        ];

        Layout.zoomeableExtensions = [
            'png', 'gif', 'jpg', 'jpeg', 'mp4', 'webp'
        ];
        Layout.googleDocsExtensions = [
            //'mov', 'avi', 'doc', 'docx', 'xls', 'xlsx', 'txt', 'pdf', 'zip', 'rar', 'html', 'htm', 'ppt', 'pptx'
        ];

        Layout.lang = ISO2_LOCALE;
        Layout.urlBucket = window.S3_URL;
        Layout.evalTimer = null;

        Layout.$Content = $("#page-content");

        Layout.menus = {};
        for (let key of [
            // old
            'dashboard', 'admin', 'reports', 'indicators', 'tools',
            // new
            'chat',
            'users',
            'modules',
            'units',
            'notifications',
            'profile.edit-company',
            'profile.edit',
            'profile.help',
        ]) {
            Layout.menus[key] = $("#main-menu [data-menu='" + key + "']");
        }

        if (typeof LayoutHeader !== "undefined") {
            LayoutHeader.init();
        }

        Layout.bindGlobalEvents();
        Layout.bindAnimations();

        setTimeout(function () {
            $(Layout.$Content).removeClass('zoomInDown');
        }, 1000);
    }

    static bindAnimations() {

    }

    /**
     * Aqui entra eventos dinamicos, que só poderão ser chamados 1x na vida da página
     */
    static bindGlobalEvents() {

        window.resizeCharts = [];
        window.disposableCharts = [];
        window.addEventListener('resize', function () {
            Layout.resizeCharts();
        })

        const $body = $('body');
        if ($body.hasClass('binded'))
            return;

        $body.addClass('binded')
            .on('click', '.clickable', function (ev) {
                if (!($(ev.target).is('.ignore, .dropdown-trigger,.main-click,.dropdown-content,.check,.fake-checkbox,.switch')
                    || $(ev.target).parents('.dropdown-trigger,.switch, .dropdown-content,.main-click,[data-unit],[data-assignments],[data-user],[data-users],[data-role],[data-company],[data-indicators],[data-module]').length
                    || $(ev.target).is('a')
                    || $(ev.target).is('[data-unit],[data-assignments],[data-user],[data-users],[data-indicators],[data-role],[data-company],[data-module]')
                )) {
                    ev.stopPropagation()
                    ev.stopImmediatePropagation();
                    $(".main-click", this).click();

                    if ($(this).hasClass('checkable')) {
                        $('input[type="checkbox"]', this).prop('checked', !$('input[type="checkbox"]', this).prop('checked')).trigger('change');
                    }
                }
            }).on('click', '.close-sidebar', function (ev) {
            ev.preventDefault();
            Layout.hideRightSidebar($(this).parents('[data-yield]').data('yield') === 'modal-sidebar');
        }).on('click', '[data-toggle]', function (ev) {
            ev.preventDefault();

            if ($(this).hasClass('active')) {
                $(this).removeClass('active');
                $($(this).data('toggle')).addClass('hidden');
            } else {
                if ($(this).data('rel')) {
                    $('[data-toggle][data-rel="' + $(this).data('rel') + '"].active').each(function () {
                        $(this).removeClass('active');
                        $($(this).data('toggle')).addClass('hidden');
                    })
                }

                $(this).addClass('active');
                $($(this).data('toggle')).removeClass('hidden');
                $("html, body").animate({scrollTop: $(this).offset().top}, 100);
            }
        }).on('click', '.sidenav-overlay', function (ev) {
            if ($body.hasClass('show-right-sidebar') && !$body.hasClass('pined-sidebar'))
                Layout.hideRightSidebar();
            if ($body.hasClass('show-modal-right-sidebar') && !$body.hasClass('pined-sidebar'))
                Layout.hideRightSidebar(true);
        }).on('click', '.sidebar-actions [data-action]', function (ev) {
            ev.stopPropagation();
            if ($(this).hasClass('disabled'))
                return false;

            if (!Layout.isModalOpen())
                $("#page-content").removeClass('zoomInDown');

            setTimeout(() => {
                if ($(this).hasClass('active') &&
                    ($('body').hasClass('open-right-sidebar') || $(Layout.topModal()).hasClass('open-right-sidebar'))) {
                    Layout.closeSidebar();
                } else {
                    Layout.openSidebar();
                    if (!$(this).hasClass('active')) {
                        $(".right-sidebar-nav .sidebar-action-content.active").removeClass('active');
                        $(".right-sidebar-nav .sidebar-actions .active").removeClass('active');
                        $(this).addClass('active');
                        $(".right-sidebar-nav .sidebar-action-content[data-action='" + $(this).data('action') + "']")
                            .addClass('animated fadeIn active');
                    }
                }
            }, 0);
        }).on('click', '.sidebar-actions', function (ev) {
            ev.stopPropagation();

            if (($('body').hasClass('open-right-sidebar') || $(Layout.topModal()).hasClass('open-right-sidebar'))) {
                Layout.closeSidebar();
            } else {
                Layout.openSidebar();
            }
        }).on('click', '.custom-tabs.with-events .tab a', function (ev) {
            ev.preventDefault();

            let $parent = $(this).parents('.custom-tabs:first');
            // hide all tabs
            $(".tab a", $parent).removeClass('active').each(function () {
                $($(this).attr('href')).addClass('hidden');
            })
            $(this).addClass('active');
            $($(this).attr('href')).removeClass('hidden').trigger('show');

        }).on('click', '.custom-modal', function (ev) {
            if ($(this).hasClass('open-right-sidebar')) {
                if (
                    $(ev.target) !== $(".right-sidebar-nav")
                    && $(ev.target).parents('.right-sidebar-nav').length === 0
                    && $(ev.target).parents('.select2-container').length === 0
                    && !$(ev.target).hasClass('fancybox-container')
                    && $(ev.target).parents('.fancybox-container').length === 0
                    && !$(ev.target).hasClass('swal2-container')
                    && $(ev.target).parents('.swal2-container').length === 0

                ) {
                    Layout.closeSidebar();
                }
            }
        }).on('click', function (ev) {
            if ($(this).hasClass('open-right-sidebar')) {
                if (
                    $(ev.target) !== $(".right-sidebar-nav")
                    && $(ev.target).parents('.right-sidebar-nav').length === 0
                    && $(ev.target).parents('.select2-container').length === 0
                    && !$(ev.target).hasClass('fancybox-container')
                    && $(ev.target).parents('.fancybox-container').length === 0
                    && !$(ev.target).hasClass('swal2-container')
                    && $(ev.target).parents('.swal2-container').length === 0

                ) {
                    Layout.closeSidebar();
                }
            }
        }).on('click', ".item-list[data-collapsible=true] .item-group-header:not(.no-drop)", function (ev) {
            if (!(
                $(ev.target).is('label')
                || $(ev.target).is('.form-control')
                || $(ev.target).parents('label:first').length
                || $(ev.target).parents('.form-control:first').length
            )) {

                ev.preventDefault();

                let $parent = $(this).parents(".item-group:first");
                let $groupList = $parent.children('.item-group-list');
                let curState = $groupList.is(':visible');

                if (curState) {
                    $parent.removeClass('is-open');
                    $parent.children('.item-group-header').find(".anchor .material-icons").html('keyboard_arrow_down');
                    $groupList.slideUp('fast');
                } else {
                    $parent.addClass('is-open');
                    $parent.children('.item-group-header').find(".anchor .material-icons").html('keyboard_arrow_up');
                    $groupList.slideDown('fast');
                }

            }
        }).on('change', ".item-list[data-collapsible=true]:not(.checkeable-disabled) .item-group-header input:not(:disabled)", function (ev) {
            let $parent = $(this).parents(".item-group:first");

            $(this).prop('indeterminate', false);

            if ($(this).is(":checked")) {
                $(".item-group-list input:not(:disabled)", $parent).prop('checked', true)
            } else {
                $(".item-group-list input:not(:disabled)", $parent).prop('checked', false);
            }
        }).on('change', ".item-list[data-collapsible=true]:not(.checkeable-disabled) .item-group-list input:not(:disabled)", function (ev) {
            let $parent = $(this).parents(".item-group:first");

            let total = $(".item-group-list input", $parent).length;
            let checked = $(".item-group-list input:checked", $parent).length;

            if (total === checked) {
                $(".item-group-header input", $parent).prop('checked', true).prop('indeterminate', false);
            } else if (checked > 0) {
                $(".item-group-header input", $parent).prop('checked', false).prop('indeterminate', true);
            } else {
                $(".item-group-header input", $parent).prop('checked', false).prop('indeterminate', false);
            }
        }).on('click', '[data-user]:not(.bindEvents)', function (ev) {
            ev.preventDefault();

            $(this).addClass('bindEvents');
            Layout.userTooltip(this);

            if (!$(ev.target).is('button') && $(ev.target).parents('button').length === 0) {
                this._tippy.show();
            }
        }).on('click', '[data-assignments]:not(.bindEvents)', function (ev) {
            ev.preventDefault();

            $(this).addClass('bindEvents');
            Layout.assignmentsTooltip(this);

            if (!$(ev.target).is('button') && $(ev.target).parents('button').length === 0) {
                this._tippy.show();
            }
        }).on('click', '[data-links]:not(.bindEvents)', function (ev) {
            ev.preventDefault();

            $(this).addClass('bindEvents');
            Layout.linksTooltip(this);

            if (!$(ev.target).is('button') && $(ev.target).parents('button').length === 0) {
                this._tippy.show();
            }
        }).on('click', '[data-role]:not(.bindEvents)', function (ev) {
            ev.preventDefault();

            $(this).addClass('bindEvents');
            Layout.roleTooltip(this);

            if (!$(ev.target).is('button') && $(ev.target).parents('button').length === 0) {
                this._tippy.show();
            }
        }).on('click', '[data-company]:not(.bindEvents)', function (ev) {
            ev.preventDefault();
            $(this).addClass('bindEvents');
            Layout.companyTooltip(this);

            this._tippy.show();
        }).on('click', '.zoomeable:not(.bindEvents)', function (ev) {
            ev.preventDefault();
            Layout.zoomeable(this);
            $(this).addClass('bindEvents').trigger('click');
        }).on('click', '[data-unit]:not(.bindEvents)', function (ev) {
            $(this).addClass('bindEvents');

            if ($(this).data('stop-propagation')) {
                ev.preventDefault();
                ev.stopPropagation();

            }

            Layout.unitTooltip(this);
            if (this._tippy)
                this._tippy.show();
        }).on('mouseenter', '[data-module]:not(.bindEvents)', function (ev) {
            $(this).addClass('bindEvents');

            if ($(this).data('stop-propagation')) {
                ev.preventDefault();
                ev.stopPropagation();

            }

            Layout.moduleTooltip(this);
            if (this._tippy)
                this._tippy.show();
        }).on('click', '[data-units]:not(.bindEvents)', function (ev) {
            $(this).addClass('bindEvents');

            if ($(this).data('stop-propagation')) {
                ev.preventDefault();
                ev.stopPropagation();
            }

            Layout.unitsTooltip(this);
            if (this._tippy)
                this._tippy.show();
        }).on('click', '[data-indicators]:not(.bindEvents)', function (ev) {
            $(this).addClass('bindEvents');

            if ($(this).data('stop-propagation')) {
                ev.preventDefault();
                ev.stopPropagation();
            }

            Layout.indicatorsTooltip(this);
            this._tippy.show();
        }).on('click', '.navigate', function (ev) {
            ev.preventDefault();
            if (!($(this).data('modal'))) {
                Layout.closeTopModal();
            }
            Http.navigate($(this).attr('href'), null, $(this).data('modal') ? $(".custom-modal:last .modal-content") : null);
        }).on('click', '.navigate-replace', function (ev) {
            ev.preventDefault();
            if (!($(this).data('modal'))) {
                Layout.closeTopModal();
            }

            let targetLoader = $(this).data('target-loader') && $($(this).data('target-loader')).length ? $($(this).data('target-loader')) : false;
            Http.navigate($(this).attr('href'), null, $(this).data('modal') ? $(".custom-modal:last .modal-content") : null, 'get', false, targetLoader);
        }).on('click', '.dropdown-trigger:not(.bindEvents,.select-dropdown)', function (ev) {
            ev.preventDefault();
            ev.stopPropagation();

            $(this).addClass('bindEvents').dropdown($(this).data()).dropdown('open');

            // vamos checar o espaço!
            //M.Dropdown.init(this);
        }).on('click', '.search:not(.bindEvents)', function (ev) {
            if ($($(this).data('target')).length) {
                new Searcher(this, $.extend($(this).data(), {dom: true}));
                $(this).addClass('bindEvents');
            }
        }).on('mouseenter', '.auto-tooltip:not(.bindEvents)', function (ev) {
            ev.preventDefault();
            ev.stopPropagation();

            Layout.tooltip($(this));
            //M.Dropdown.init(this);
        }).on('mouseenter', '[data-tooltip]:not(.bindEvents)', function (ev) {
            ev.preventDefault();
            ev.stopPropagation();

            Layout.tooltip($(this));
            //M.Dropdown.init(this);
        }).on('mouseenter', '.open-modal:not(.bindEvents)', function (ev) {
            ev.preventDefault();
            ev.stopPropagation();

            $(this).addClass('bindEvents').modal();
            //M.Dropdown.init(this);
        }).on('click', '.select2-results__group', function () {
            if ($(this).parents('.select2-results__options[aria-multiselectable="true"]').length) {
                let id = $(this).parents('.select2-results__options[aria-multiselectable="true"]').attr('id');
                id = id.substring(0, id.length - 1) + '-';
                let thisGroup = $(this).parent().data('select2-id');
                let selected = [];
                $(this).parents('.select2-results__options:first').children('.select2-results__option').each(function () {
                    if ($(this).data('select2-id') == thisGroup) {
                        if ($(".select2-results__option[aria-selected='true']", this).length !=
                            $(".select2-results__option", this).length
                        ) {
                            $(".select2-results__option", this).each(function () {
                                let t = $(this).data('select2-id').replace(id, '').split('-');
                                t.shift();
                                selected.push(t.join('-'));
                                $(this).attr('aria-selected', true);
                            })
                        } else {
                            $(".select2-results__option", this).attr('aria-selected', false);
                        }
                    } else {
                        $(".select2-results__option[aria-selected='true']", this).each(function () {
                            let t = $(this).data('select2-id').replace(id, '').split('-');
                            t.shift();
                            selected.push(t.join('-'));
                        })
                    }
                });

                if (Layout.select2_open_element)
                    Layout.select2_open_element.val(selected).trigger('change');

                $(this).parent().find('li').each(function () {
                    $(this).trigger('mousedown');
                    this.dispatchEvent(new Event('select'));
                });
            }
        }).on('click', '.key-value-input .add-record', function (ev) {
            ev.preventDefault();

            let $parent = $(this).parents('.key-value-input');

            const idx = $parent.find('tbody').data('idx');
            let $template = $parent.find('template').html().replace(/IDX/g, idx);
            $parent.find('tbody').append($template).find('tr:last input:visible:first').focus();
            $parent.find('tbody').data('idx', idx + 1);
        }).on('click', '.key-value-input .remove', function (ev) {
            ev.preventDefault();

            $(this).parents('tr:first').remove();
        }).on('click', '.materialize-textarea', function (ev) {
            Layout.textareaAutoResize($(this));
        }).on('keyup', '.materialize-textarea', function (ev) {
            Layout.textareaAutoResize($(this));
        }).on('keydown', '.materialize-textarea', function (ev) {
            Layout.textareaAutoResize($(this));
        }).on('resize-input', '.materialize-textarea', function (ev) {
            Layout.textareaAutoResize($(this));
        }).on('click', '.dropdown-trigger-off', async function (ev) {
            ev.stopPropagation();
            ev.preventDefault();
            let $this = $(this);

            let $target = $($this.attr('data-target'));

            if ($target.length === 0 && $this.attr('data-delay')) {
                await new Promise(res => {
                    let interVal = setInterval(() => {
                        $target = $($this.attr('data-target'));
                        if ($target.length) {
                            clearInterval(interVal);
                            res();
                        }
                    }, 25);
                })
            }

            if ($target && !($target.data('active'))) {
                $target.data('parent', $target.parent());

                const $toBody = $this.attr('data-to-body') || false;

                let scrollEl = null;

                if ($toBody) {
                    scrollEl = document.body;
                    $target.appendTo('body');
                } else if ($this.attr('data-append-to')) {
                    scrollEl = $($this.attr('data-append-to'))[0];
                    if (scrollEl) {
                        $target.appendTo(scrollEl);
                    }
                }

                let placementVertical = 'auto';
                let placementHorizontal = 'auto';

                if ($target.attr('data-placement')) {
                    let $t = $target.attr('data-placement').split('-');

                    if ($t.length > 1) {
                        placementVertical = $t[0];
                        placementHorizontal = $t[1];
                    } else if (['right', 'left'].indexOf($t[0]) >= 0) {
                        placementHorizontal = $t[0];
                    } else if (['top', 'bottom'].indexOf($t[0]) >= 0) {
                        placementVertical = $t[0];
                    }
                }

                if (scrollEl) {
                    let $offset = getCoords($this[0]);
                    if (placementHorizontal == 'auto') {
                        if ($offset.left + $target.outerWidth() > scrollEl.scrollWidth) {
                            placementHorizontal = 'left';
                        } else {
                            placementHorizontal = 'right';
                        }
                    }

                    if (placementHorizontal == 'right') {
                        let right = $(window).width() - $offset.left - $this.outerWidth() - 10;

                        // scrollEl.scrollWidth

                        if (scrollEl.scrollWidth - $offset.left - $this.outerWidth() - 10 < 10) {
                            right = $(window).width() - scrollEl.scrollWidth + 10;
                        }

                        let left = 'auto';
                        if (right + 10 > scrollEl.scrollWidth) {
                            right = 'auto';
                            left = 10;
                        }

                        /*let left = $offset.left - $target.outerWidth() + $this.outerWidth();

                        if (left + $target.outerWidth() > document.body.scrollWidth) {
                            left = document.body.scrollWidth - $target.outerWidth() - 10;
                        }*/
                        $target.css({
                            right,
                            left
                        })
                    } else if (placementHorizontal == 'left') {
                        let left = $offset.left;

                        if (left + $target.outerWidth() > scrollEl.scrollWidth) {
                            left = scrollEl.scrollWidth - $target.outerWidth() - 10;
                        }

                        $target.css({
                            left
                        })
                    }

                    if (placementVertical == 'auto') {
                        if ($offset.top + $target.outerHeight() + 20 > scrollEl.scrollHeight) {
                            placementVertical = 'bottom';
                        } else {
                            placementVertical = 'top';
                        }
                    }

                    if (placementVertical == 'top') {
                        $target.css({
                            top: $offset.top + $this.outerHeight() + 10
                        })
                    } else if (placementVertical == 'bottom') {
                        $target.css({
                            bottom: 'auto',
                            top: $offset.top - $target.outerHeight() - 10
                        })
                    }
                }


                /*if ($target.offset().left + $target.outerWidth() > $('body').scrollWidth() ) {
                    $target.css({
                        left: $this.offset().left - ($target.offset().left + $target.outerWidth() - $('body').width())
                    })
                }*/
                if ($target.offset().top + $target.outerHeight() > document.body.scrollHeight) {
                    /*$target.css({
                        top: $this.offset().top - ($target.offset().top + $target.outerHeight() - $('body').height())
                    })*/
                }

                if (!$toBody && placementVertical == 'auto') {
                    $target.css({bottom: 'auto', top: $this.outerHeight() + 10});

                    if ($this.offset().top + $this.outerHeight() + 10 + $target.outerHeight() > document.body.scrollHeight - parseInt($target.attr('data-offset-height-bottom'))) {
                        $target.css({bottom: $this.outerHeight() + 10, top: 'auto'});
                    }

                }

                let $btn = $this;

                if ($('.icon-target', this).length) {
                    $btn = $('.icon-target', this);
                } else if ($('.btn', this).length) {
                    $btn = $('.btn', this);
                }


                $btn.addClass('dropdown-active');
                if ($this.attr('data-icon') != 'false') {
                    $btn.attr('data-old_class', $btn.hasClass('ci-plus') ? 'ci-plus' : ($btn.hasClass('ci-more_vertical') ? 'ci-more_vertical' : ''))
                    $btn.removeClass('ci-more_vertical ci-plus').addClass('ci-close_big');
                }
                Layout.restoreDropdown($(".dropdown-content-off.active:not(" + $this.attr('data-target') + ")"));


                let $parent = $(ev.target).parents('.dropdown-container:first');
                if ($parent.length) {
                    $parent.find('[data-dropdown-active=1]')
                        .attr('data-dropdown-active', 0);
                    $(".dropdown-content-off.active", $parent).removeClass('active');

                    $parent.find('[data-dropdown-active=1]')
                        .attr('data-dropdown-active', 0);
                }


                $(ev.target).parents('.drop-row:first').attr('data-dropdown-active', 1)
                $(ev.target).parents('.drop-row-group:first').attr('data-dropdown-active', 1);


                $target.data('active', this)
                    .addClass('active');

            } else {
                Layout.restoreDropdown($target);
            }

        }).on('click.dropdown-off', function (ev) {
            if (!$(ev.target).hasClass('dropdown-trigger-off')
                && !$(ev.target).parents('.dropdown-trigger-off').length
                && !$(ev.target).hasClass('dropdown-content-off')
                && ($(ev.target).attr('data-auto-close') === undefined
                    || $(ev.target).attr('data-auto-close') != 0)
                && !$(ev.target).parents('[data-auto-close=0]').length
            ) {
                Layout.restoreDropdown($(".dropdown-content-off.active"));
            }
        }).on('click', ".copy-raw-value:not(.bindedEvent)", function (ev) {
            ev.preventDefault();

            copyTextToClipboard($(this).data('value'), _t('Value copied to clipboard!'));
        }).on('click', ".translatable .lang-tabs li", function (ev) {
            ev.preventDefault();

            const group = $(this).parents('.translatable:first');

            group.find('.lang-tabs li').removeClass('active');
            $(this).addClass('active');

            $('.form-control[data-lang]', group).removeClass('active');
            $('.form-control[data-lang="' + $(this).data('lang') + '"]', group).addClass('active');

            if (group.data('default-language') == $(this).data('lang')) {
                $(".auto-translate", group).addClass('hidden');
            } else {
                $(".auto-translate", group).removeClass('hidden');
            }
        }).on('click', ".translatable .auto-translate:not(.standalone)", async function (ev) {
            ev.preventDefault();

            const group = $(this).parents('.translatable:first');
            const source = group.data('default-language');
            const $sourceEl = $('.form-control[data-lang="' + source + '"]', group);
            const target = $('.lang-tabs li.active', group).data('lang');
            let term = $sourceEl.val();
            if (group.data('html')) {
                term = $sourceEl.data().form.getValue();
            } else if ($sourceEl.data('editor')) {
                term = $sourceEl.data().editor.getContent();
            }

            if (term.length > 2) {
                const targetEl = $('.form-control[data-lang="' + target + '"]', group);

                if (group.data('html')) {
                    targetEl.data().form.setValue('...');
                } else if (targetEl.data('editor')) {
                    targetEl.data().editor.setContent('...');
                } else {
                    targetEl.val('...');
                }

                let res = await Http.get('/translate/term/' + source + '/' + target
                    + '?text=' + encodeURIComponent(term), {
                    cache: true
                });

                targetEl.trigger('translated', [res.data]);

                if (group.data('html')) {
                    targetEl.data().form.setValue(res.data);
                } else if (targetEl.data('editor')) {
                    targetEl.data().editor.setContent(res.data);
                } else {
                    targetEl.val(res.data).trigger('change');

                    targetEl[0].dispatchEvent(new Event('input'));
                }
            } else {
                Layout.toastWarning(_t('The text must have at least 3 characters to be translated'));
            }
        }).on('change', ".form-control", async function (ev) {
            ev.preventDefault();

            const group = $(this).parents('.translatable:first');
            if (group) {
                const target = $('.lang-tabs li.active', group);

                if ($.trim($(this).val()) === '') {
                    target.addClass('empty');
                } else {
                    target.removeClass('empty');
                }
            }

        })

    }

    static restoreDropdown($dropdowns) {
        $dropdowns.each(function () {
            $(this).removeClass('active');

            if ($(this).data('active')) {
                if ($(this).data('parent')) {
                    $(this).appendTo($(this).data('parent'));
                }

                const $parent = $($(this).data('active'));
                let $btn;
                if ($('.icon-target', $parent).length) {
                    $btn = $('.icon-target', $parent);
                } else if ($('.btn', $parent).length) {
                    $btn = $('.btn', $parent);
                } else {
                    $btn = $parent;
                }

                $btn.removeClass('dropdown-active');
                if ($parent.data('icon') !== false) {
                    $btn.removeClass('ci-close_big')
                        .addClass($btn.data('old_class'));
                }
                $(this).data('active', false);
            }
        })
    }

    static getSelect2Language() {
        return {
            errorLoading: function () {
                return _t('The results could not be loaded.')
            },
            inputTooLong: function (e) {
                return _t("Please delete {0} characters", e.input.length - e.maximum, _t("Please delete 1 character"));
            },
            inputTooShort: function (e) {
                return _t("Please enter {0} or more characters", [e.minimum - e.input.length]);
            },
            loadingMore: function () {
                return _t("Loading more results…")
            },
            maximumSelected: function (e) {
                return _t("You can only select {0} items", e.maximum, _t('"You can only select 1 item"'));
            },
            searching: function () {
                return _t("Searching…")
            },
            removeAllItems: function () {
                return _t("Remove all items")
            },
            noResults: function () {
                return _t("No results found")
            },
        }
    }

    /**
     * Aqui entra eventos que são atribuidos sempre que há conteúdo novo
     * @param $container
     * @param forceAutoInit
     */
    static bindEvents($container = null, forceAutoInit = false) {
        let autoinit = !forceAutoInit ? ':not(.no-autoinit):not(.bindEvents)' : ':not(.bindEvents)';

        Layout.unitTooltip('[data-unit]' + autoinit, $container);
        Layout.userTooltip('[data-user]' + autoinit, $container);
        Layout.linksTooltip('[data-links]' + autoinit, $container);
        Layout.roleTooltip('[data-role]' + autoinit, $container);
        Layout.companyTooltip('[data-company]' + autoinit, $container);
        Layout.tooltip('[data-tooltip]' + autoinit + ', .tooltip' + autoinit, $container);


        Layout.ajaxTooltip('[data-ajax-tooltip]' + autoinit, $container);
        if ($.fn.modal) {
            $('.open-modal' + autoinit, $container).addClass('bindEvents').modal();
        }
        if ($.fn.sideModal)
            $('.open-sidemodal' + autoinit, $container).addClass('bindEvents').sideModal();
        $('.zoomeable' + autoinit, $container).each(function () {
            Layout.zoomeable(this);
        }).addClass('bindEvents');

        let $companySelector = $(".environment-selector:not(.binded)");
        if ($companySelector.length) {
            $companySelector.each(function () {
                const $this = $(this);
                $this.val('company:' + ACTIVE_COMPANY)
                    .addClass('binded')
                    .select2({
                        placeholder: $companySelector.data('placeholder'),
                        dropdownAutoWidth: true,
                        templateResult: function (item) {
                            return $(`<span class="flex items-center"><img src="${cdn_url($(item.element).data('src'))}" class="mr-2 rounded-full" width="20" height="20"/>` + item.text + '</span>');
                        },
                        templateSelection: function (item) {
                            return $(`<span class="flex items-center"><i class="ci-building mr-2 text-xl"></i>` + item.text + '</span>');
                        }
                    }).on('select2:select', async function (e) {
                    const terms = this.value.split(':');

                    if ($this.data('selector-only')) {
                    } else if (terms[0] === 'company')
                        LayoutHeader.changeCompany(terms[1]);
                    else
                        window.location = 'auth/representative/' + terms[1];
                });
            });

        }

        $(".materialize-textarea" + autoinit, $container).addClass('bindEvents').each(function () {
            //$(this).trigger('autoresize');
            const $textarea = $(this);
            $textarea.data('original-height', $textarea.height());
            $textarea.data('previous-length', $textarea.val().length === 0 ? ($textarea.attr('placeholder') ? $textarea.attr('placeholder').length : 0) : $textarea.val().length);
            Layout.textareaAutoResize($textarea);
        })

        $("select.searchable" + autoinit, $container).addClass('bindEvents browser-default').each(function () {
            /*if ($(this).outerWidth() === $(this).parent().width()) {
                $(this).addClass('resizable').data('originalWidth', $(this).outerWidth());
            }
            if ($(this).data('width') === '100%') {
                $(this).data('width', $(this).outerWidth()).attr('data-width',$(this).outerWidth()+'px');
            }*/

            let data = $(this).data();
            if (!data)
                data = {}
            if (data.allowClear === undefined)
                data.allowClear = true;

            if ($(this).prop('multiple') && $(this).data('closeOnSelect') != true) {
                data.closeOnSelect = false;
            }

            $(this).select2(extend({language: Layout.getSelect2Language()}, $(this).data())).on('select2:open', function (ev) {
                Layout.select2_open_element = $(this);
            });
        });

        $(".decimal-mask" + autoinit, $container).addClass('bindEvents').each(function () {
            applyDecimalMask($(this), $(this).data('decimals') ?? 0);
        });

        $("select.taggable" + autoinit, $container).addClass('bindEvents browser-default').each(function () {
            const noValue = $(this).data('no-value') || _t('Type your value');
            const prefix = $(this).data('new-tag-prefix') || '';
            $(this).select2(extend({
                    tags: true,
                    width: '100%',
                    allowClear: true,
                    placeholder: $(this).data('placeholder'),
                    createTag: function (params) {
                        return {id: params.term, text: prefix + params.term};
                    },
                    language: extend(Layout.getSelect2Language(), {
                        noResults: function () {
                            return noValue;
                        },
                    }),
                    dropdownCssClass: 'select2-on-filter',
                    templateResult: function (item) {
                        return item.text;
                    },
                    templateSelection: function (item) {
                        return item.text;
                    }
                }, ($(this).data('url') ? {
                    ajax: {
                        url: url($(this).data('url')),
                        data: function (params) {
                            return params;
                        },
                        dataType: 'json',
                        processResults: function (data) {
                            return {
                                results: data.map(function (row) {
                                    return {id: row, text: row};
                                }),
                                pagination: {
                                    more: data.length === 10
                                }
                            };
                        },
                        cache: true
                    }
                } : {})
            ));
        });


        $("select.common-alternative-selector" + autoinit, $container).addClass('bindEvents browser-default').each(function () {
            const include_children = $(this).data('include-children') || false ? 1 : 0;
            const $thisEl = $(this);
            const type = $thisEl.data('type');

            $thisEl.data('setValue', async function (val) {
                $thisEl.next('.select2').block();

                let res = await Http.post('indicator/alternatives/commons', {
                    ids: [val],
                    type: type
                })
                for (let row of res.data) {
                    if (row.common_alternatives_type_id == type && val == row.id) {
                        $thisEl.data('extra', row.data);
                        $thisEl.data('selected_extra', row.data);
                        $thisEl.data('selected_id', row.id);
                        const image = row.image || '';
                        $thisEl.html('<option value="' + row.id + '" data-image="' + image + '" selected>' + row.value + '</option>').trigger('change');
                    }
                }

                $thisEl.next('.select2').unblock();
            }).select2({
                allowClear: !this.hasAttribute('multiple'),
                language: Layout.getSelect2Language(),
                closeOnSelect: $(this).data('closeOnSelect') || !this.hasAttribute('multiple'),
                placeholder: $(this).data('placeholder'),
                ajax: {
                    url: url((window.noauth ? external_url('') : '') + '/indicator/alternatives/commons/' + type),
                    data: function (params) {
                        params.include_children = include_children;
                        return params;
                    },
                    dataType: 'json',
                    processResults: function (data) {
                        return {
                            results: data,
                            pagination: {
                                more: data.length === 10
                            }
                        };
                    },
                    cache: true
                },
                escapeMarkup: function (markup) {
                    return markup;
                },
                templateResult: function (item) {
                    let output = item.value || item.text || '';
                    if (item.image && item.image !== '') {
                        output = '<span class="inline-flex items-center"><img src="' + S3_URL + '/alternatives/thumb/' + item.image + '" class="mr-2 rounded" style="height: 80px" />' + output + '</span>';
                    }
                    return output;
                },
                templateSelection: function (item) {
                    let $extra = item.data;
                    if (!item.data && item.element)
                        $extra = $(item.element).data('extra');
                    // tem um bug estranho, que quando você seleciona o mesmo item que vem selecionado, ele da undefined pro data
                    if (!($extra) && item.id == $thisEl.data('selected_id')) {
                        $extra = $thisEl.data('selected_extra');
                    }

                    $thisEl.data('extra', $extra);

                    let output = item.value || item.text || '';
                    const imgSrc = item.image || $(item.element).data('image');
                    if (imgSrc && imgSrc !== '') {
                        output = '<span class="inline-flex items-center"><img src="' + S3_URL + '/alternatives/thumb/' + imgSrc + '" class="mr-2 rounded" style="height: 80px" />' + output + '</span>';
                    }
                    return output;
                }


            }).on('select2:select', function (e) {

            }).on('select2:unselecting', function (e) {
                $thisEl.data('extra', false);
            }).on('select2:open', function (ev) {
                Layout.select2_open_element = $(this);
            });


        });

        $(".datetimepicker" + autoinit, $container).addClass('bindEvents').each(function () {
            let data = $(this).data();

            flatpickr(this, extend({
                altInput: true,
                enableTime: true,
                altFormat: Internationalization.getDatePickerPattern(true) + ' H:i',
                timeFormat: 'H:i',
                locale: window.ISO2_LOCALE,
                time_24hr: true
            }, data));
            if ($(this).is('[readonly]')) {
                $(this).next('.datetimepicker').prop('disabled', true);
            }
        });

        $(".datetimepicker-container" + autoinit, $container).addClass('bindEvents').click(function (ev) {
            if (ev.target.classList.contains('datetimepicker'))
                return;
            $(this).find('.datetimepicker').trigger('focus');
        })


        $('select[multiple]:not(.browser-default):not(.swal2-select)' + autoinit, $container).addClass('bindEvents browser-default').each(function () {
            let data = $.fn.multipleSelect.locales[ISO_LOCALE];

            if ($(this).data('formatallselected')) {
                const label = $(this).data('formatallselected');
                data.formatAllSelected = () => label;
            }
            if ($(this).data('formatcountselected')) {
                const label = $(this).data('formatcountselected');
                data.formatCountSelected = (l1, l2) => label.replace('{0}', l1).replace('{1}', l2);
            }
            $(this).multipleSelect(extend({
                filter: true,
                dropWidth: Math.max(400, $(this).width())
            }, data));
        });

        let registry = {
            //Autocomplete: '.autocomplete',
            //Carousel: '.carousel',
            Chips: '.chips',
            Collapsible: '.collapsible',
            Datepicker: '.datepicker',
            Dropdown: '.dropdown-trigger:not(.select-dropdown)',
            //Materialbox: 'img.materialboxed',
            //Modal: '.modal',
            //Parallax: '.parallax',
            //Pushpin: '.pushpin',
            //ScrollSpy: '.scrollspy',
            FormSelect: 'select:not(.browser-default):not(.swal2-select):not(.searchable):not([multiple]):not(.phpdebugbar-datasets-switcher):not(.flatpickr-monthDropdown-months)',
            //FormSelectMultiple: 'select[multiple]:not(.browser-default):not(.swal2-select)',
            //Sidenav: '.sidenav',
            Tabs: '.tabs',
            //TapTarget: '.tap-target',
            Timepicker: '.timepicker',
            //Tooltip: '.tooltipped',
            FloatingActionButton: '.fixed-action-btn'
        };


        for (let pluginName in registry) {
            $(registry[pluginName] + autoinit, $container).each(function () {
                let data = $(this).data();
                if (pluginName === 'Dropdown' && $(this).data('tooltipLoaded')) {
                    let originalCloseEnd = data.onCloseEnd;
                    let $el = this;
                    data.onCloseEnd = function () {
                        if (typeof originalCloseEnd === 'function') {
                            originalCloseEnd();
                        }
                        $el._tippy.hide();
                    }
                    let onOpenStart = data.onOpenStart;
                    data.onOpenStart = function () {
                        if (typeof onOpenStart === 'function') {
                            onOpenStart();
                        }
                        $el._tippy.hide();
                    }
                } else if (pluginName === 'Datepicker') {
                    Layout.datepicker($(this), data);
                    return;
                } else if (pluginName === 'Tabs') {
                    data = $.extend(data, {
                        onShow: function (tab) {
                            $(tab).trigger('tab:shown');

                            $(".materialize-textarea", tab).each(function () {
                                Layout.textareaAutoResize($(this));
                            })
                        }
                    });
                    M.Tabs.init(this, data);
                    return;
                } else if (pluginName === 'FormSelectMultiple') {
                    Layout.formSelectMultiple($(this), data);
                    return;
                } else if (pluginName === 'FormSelect') {
                    if (data && typeof data.closeOnClick === 'undefined') {
                        data.closeOnClick = true;
                    }
                }
                M[pluginName].init(this, data);
            }).addClass('bindEvents');
        }

        $(".btn:not(.waves-effect)", $container).addClass('waves-effect waves-light');

        $(".search" + autoinit, $container).each(function () {
            if ($($(this).data('target')).length) {
                new Searcher(this, $.extend($(this).data(), {dom: true}));

                $(this).addClass('bindEvents');
            }
        });

        return $container;
    }

    static formSelectMultiple(element, data) {

        let instance;
        let updateTippy = function () {
            if (!instance)
                return;
            if (instance.input.scrollWidth > $(instance.input).outerWidth()) {
                Layout.tooltip(instance.input, null, {
                    content: instance.input.value
                });
            } else if (instance.input._tippy) {
                instance.input._tippy.destroy()
                $(instance.input).data('tooltipLoaded', false);
            }
        };

        data = $.extend(true, data, {
            closeOnClick: false,
            dropdownOptions: {
                onCloseEnd: function () {
                    updateTippy();
                },
                closeOnClick: false,
                onOpenStart: function () {
                    if ($(".check-all", this.dropdownEl).length === 0) {
                        let $dropdownEl = this.dropdownEl;

                        let checked = $('input', $dropdownEl).length ===
                        $('input:checked', $dropdownEl).length ? 'checked' : '';
                        this.$dropdownEl.prepend(`<li tabindex="0">
                                <span><label><input type="checkbox" ${checked} class="check-all"><span>${_t('Check all')}</span>
                                </label></span></li>`);

                        $(".check-all", this.dropdownEl).change(function () {
                            $('input:not(.check-all)' + ($(this).is(':checked') ? ':not(:checked)' : ':checked'), $dropdownEl).each(function () {
                                $(this).parents('li:first').trigger('click');
                            });
                            $(this).parents('.select-wrapper:first').find('.dropdown-trigger').click();
                        });
                    }
                }
            }
        });


        instance = M.FormSelect.init($(element).change(function () {
            timeout(() => {
                $(".check-all", instance.dropdownOptions).prop('checked', ($('input:not(.check-all)', instance.dropdownOptions).length ===
                    $('input:not(.check-all):checked', instance.dropdownOptions).length));
            })
        }), data)[0];
        updateTippy();
    }

    static toast(msg, icon = '', displayLength = 4000, classes = '', completeCallback = null) {
        M.toast({
            displayLength,
            classes,
            completeCallback,
            html: (icon ? '<i class="material-icons left">' + icon + '</i> ' : '') + msg
        })
    }


    static toastInfo(msg, timeout = 4000) {
        Layout.toast(msg, 'info', timeout);
    }

    static toastWarning(msg, timeout = 4000, icon = 'warning') {
        Layout.toast(msg, icon, timeout, 'orange darken-1');
    }

    static toastDanger(msg, timeout = 4000) {
        Layout.toast(msg, 'cancel', timeout, 'red darken-3');
    }

    static toastError(msg, timeout = 4000) {
        Layout.toastDanger(msg, timeout);
    }

    static toastSuccess(msg, timeout = 4000) {
        Layout.toast(msg, 'check', timeout, 'green darken-3');
    }

    static toastMessage(msg, timeout = 9000) {
        Layout.toast(msg, 'message', timeout);
    }

    static async alertValidationMessage(message) {
        Swal.showValidationMessage(message);
    }

    /**
     * Documentação: https://sweetalert2.github.io/
     * @param options
     * @return {Promise<unknown>}
     */
    static async alert(options = {}) {
        if (typeof options === 'string')
            options = {content: options};

        let $default = {
            title: _t('Attention'),
            icon: 'warning',
            showCancelButton: false,
            reverseButtons: true,
            cancelButtonText: _t('Cancel'),
            customClass: {
                confirmButton: 'waves-effect waves-light btn',
                cancelButton: 'waves-effect waves-light btn grey lighten-1',
            },
            confirmButtonText: _t('OK')
        };

        if (options.customClass) {
            options.customClass = $.extend($default.customClass, options.customClass);
        }

        $default = extend($default, options);

        if ($default.content) {
            $default.html = $default.content;
            delete $default.content;
        }

        if ($default.preConfirm) {
            $default.showLoaderOnConfirm = true;
            $default.allowOutsideClick = () => !Swal.isLoading();
        }

        let icon = $default.icon ? $default.icon : false;
        let defaultIcons = ["success", "error", "warning", "info", "question"];
        let customIcon = false;
        if (icon && defaultIcons.indexOf(icon) === -1) {
            $default.icon = 'question';
            customIcon = true;
        }
        if ($default.url || customIcon) {
            if ($default.url) {
                $default.text = null;
                $default.html = `<div class="preloader-wrapper big active">
    <div class="spinner-layer spinner-blue-only">
      <div class="circle-clipper left">
        <div class="circle"></div>
      </div><div class="gap-patch">
        <div class="circle"></div>
      </div><div class="circle-clipper right">
        <div class="circle"></div>
      </div>
    </div>
  </div>`;
            }
            // vamos fazer fetch, então vamos introduzir um html com loading!
            let originalOnBeforeOpen = $default.onBeforeOpen;
            let originalOnOpen = $default.onOpen;
            let $url = $default.url;
            delete $default.url;
            delete $default.onOpen;

            $default.onBeforeOpen = function ($modal) {
                if (customIcon) {
                    $(".swal2-question .swal2-icon-content", $modal)
                        .html('<span class="material-icons">' + icon + '</span>');
                }

                if ($url) {
                    $(".swal2-actions", $modal).hide();
                    ($url instanceof Promise ? $url : Http.get($url)).then((res) => {
                        let $container = $(".swal2-html-container", $modal).html(res.data);
                        Layout.bindEvents($container, true);
                        Layout.evalScripts($container);

                        if (originalOnOpen) {
                            originalOnOpen($modal);
                        }
                    }, (error) => {
                        $(".swal2-html-container", $modal).html(`<div class="warning">
                            <i class="material-icons">warning</i> ${_t('An error occurred with the request, try again')}`);

                        $(".swal2-actions button:not(.swal2-cancel)").remove();


                    }).finally(() => {
                        $(".swal2-actions", $modal).show();
                    });

                } else {

                    Layout.bindEvents($(".swal2-html-container", $modal), true);
                }

                if (originalOnBeforeOpen) {
                    originalOnBeforeOpen($modal);
                }
            }

        }

        return new Promise((resolve, fail) => {
            Swal.fire($default).then((result) => {
                if (result.value !== false) {
                    resolve(result.value);
                } else {
                    resolve(false);
                }
            })
        });
    }

    static async alertSuccess(options = {}) {
        return Layout.alert($.extend({
            icon: 'success'
        }, options));
    }

    static async alertInfo(options = {}) {
        return Layout.alert($.extend({
            icon: 'info',
            title: _t('Attention!'),
        }, options));
    }

    static async alertError(options = {}) {
        return Layout.alert($.extend({
            icon: 'error',
            title: _t('Something went wrong!'),
            text: _t("An error occurred with the request, try again."),
        }, options));
    }

    static closeAlert(data = null) {
        Swal.close(data);
    }

    static async confirm(options = {}) {
        return Layout.alert($.extend({
            showCancelButton: true,
            title: _t('Are you sure?'),
            text: _t("You won't be able to revert this!"),
        }, options));
    }


    static async confirmDelete(options = {}) {
        return Layout.alert($.extend({
            showCancelButton: true,
            title: _t('Are you sure?'),
            customClass: {
                confirmButton: 'waves-effect waves-light btn btn-danger',
            },
            text: _t('Are you sure you want to delete this item permanently?'),
            confirmButtonText: '<i class="material-icons ">delete_forever</i> ' + _t('Delete'),
        }, options));
    }

    static loader(show) {
        if (show) {
            $("#Loader").show();
        } else {
            $("#Loader").hide();
        }
    }

    static showRightSidebar(modal = false, multiple = false) {
        $('body').addClass('show-overlay show-' + (modal ? 'modal-' : '') + 'right-sidebar');
        $("." + (modal ? 'modal-' : '') + "right-sidebar-nav").css('left', 'calc(100% - ' + $('.' + (modal ? 'modal-' : '') + 'right-sidebar-nav').width() + 'px)');

        if (multiple !== false) {
            $(".right-sidebar-nav > *").addClass('hidden');
            $(multiple).removeClass('hidden');
        }
        return false;
    }

    static hideRightSidebar(modal = false) {
        $('body').removeClass('show-overlay show-' + (modal ? 'modal-' : '') + 'right-sidebar');
        $('.' + (modal ? 'modal-' : '') + 'right-sidebar-nav > .sidebar-actions > .active').removeClass('active');
        $("." + (modal ? 'modal-' : '') + "right-sidebar-nav").css('left', '100%');
        return false;
    }

    static loaderContent($el, show) {
        if ($el === false)
            return;
        if (show) {
            $el.block({
                css: {
                    top: 'calc(50% - 32px)',
                    left: 'calc(50% - 32px)',
                    width: 64,
                    height: 64,
                    backgroundColor: 'none'
                },
                message: `
                      <div class="preloader-wrapper big active">
                        <div class="spinner-layer">
                          <div class="circle-clipper left">
                            <div class="circle"></div>
                          </div><div class="gap-patch">
                            <div class="circle"></div>
                          </div><div class="circle-clipper right">
                            <div class="circle"></div>
                          </div>
                        </div>
                      </div>`
            });
        } else {
            $el.unblock();
        }
    }

    static evalScripts($target = null, $targetParent = null) {
        if (!Layout.$LoadedScripts) {
            Layout.$LoadedScripts = {};
            Layout.$LoadedLink = {};
        }
        if ($target === null) {
            $target = Layout.$Content;
        }

        if ($targetParent === null) {
            $targetParent = $("#page");
        }

        let scripts = [], styles = [];

        let after_load = function () {
            let div = document.createElement('div');
            div.innerHTML = this.innerHTML;
            let tmpScript = '';
            let tmpModule = null;
            $("script", div).each(function () {
                const module = this.getAttribute('type') === 'module';

                if (this.getAttribute('src')) {
                    //const script = document.createElement('script');

                    if (tmpScript !== '') {
                        scripts.push({
                            code: tmpScript,
                            isCode: true,
                            unique: false,
                            module
                        });
                        tmpScript = '';
                        tmpModule = null;
                    }

                    scripts.push({
                        code: this.getAttribute('src'),
                        isCode: false,
                        unique: this.getAttribute('data-unique') == 1,
                        module
                    });
                } else {
                    if (tmpModule === null)
                        tmpModule = module;
                    else if (tmpModule !== module) {
                        scripts.push({
                            code: tmpScript,
                            isCode: true,
                            unique: false,
                            module: tmpModule
                        });
                        tmpScript = '';
                        tmpModule = module;
                    }

                    tmpScript += this.innerHTML + ';\n';

                }
            });

            if (tmpScript !== '') {
                scripts.push({
                    code: tmpScript,
                    isCode: true,
                    unique: false,
                    module: tmpModule ?? false
                });
                tmpScript = '';
            }

            $("link", div).each(function () {
                styles.push({
                    code: this.getAttribute('href'),
                    isCode: false
                });
            });
            $("style", div).each(function () {
                styles.push({
                    code: this.innerHTML,
                    isCode: true
                });
            });

            $(this).remove();
        }

        if (!Layout.firstEval) {
            $("template[type='yield']", $target).each(function () {
                Layout.bindEvents($("[data-yield='" + $(this).data('section') + "']").html(this.innerHTML));
            }).remove();
        }
        $("template[type='after_load']", $target).each(after_load).remove();
        $("template[type='after_load_end']", $target).each(after_load).remove();


        AssetLoader.addStyles(styles);
        AssetLoader.addScripts(scripts);
        Layout.firstEval = false;
    }

    /**
     * Cria um modal
     * @param url
     * @param options
     modalTarget: $modalTrigger ? $modalTrigger.attr('href').replace('#','') : '',
     position:'fixed',
     width:'100%',
     height:'100%',
     top:'0px',
     left:'0px',
     content:'',
     url: $modalTrigger && $modalTrigger.attr('href').indexOf('#') === -1 ? $modalTrigger.attr('href') : '',
     id:'',
     data: null,
     class: 'large',
     destroyOnClose: true,
     showFooter: false,
     fluid: false,
     footerClass: '',
     footer: '',
     zIndexIn: 1000 + $(".custom-modal:visible").length,
     zIndexOut: '-1000',
     color: '#f4fbfe',
     opacityIn:'1',
     opacityOut:'0',
     animatedIn:'zoomIn',
     animatedOut:'zoomOut',
     animationDuration:'.6s',
     //overflow:'auto',
     // Callbacks
     beforeOpen: function() {},
     afterOpen: function() {},
     beforeClose: function() {},
     afterLoaded: function() {},
     afterClose: function() {}

     * @return {Promise<unknown>}
     */
    static async modal(url, options = {}) {
        return new Promise((resolve) => {
            Layout.canChangeTitle = false;
            if (options.afterOpen) {
                let afterOpen = options.afterOpen;
                options.afterOpen = function () {
                    afterOpen();
                    Layout.canChangeTitle = true;
                    resolve(true);
                };
            }
            $.modal($.extend({
                url,
                afterOpen: function () {
                    Layout.canChangeTitle = true;
                    resolve(true);
                }
            }, options));
        })
    }

    static isModalOpen() {
        return $(".modal:visible").length > 0;
    }

    static showFooterBar() {
        $('body').addClass('show-footerbar');
        timeout(function () {
            $("body").addClass('footerbar-opened');
        }, 300, 'footerbar');
    }

    static hideFooterBar() {
        $('body').removeClass('show-footerbar');
    }

    static closeSidebar() {
        if (Layout.isModalOpen()) {
            Layout.topModal(true)
                .removeClass('open-right-sidebar');

            timeout(function () {
                if (Layout.isModalOpen()) {
                    Layout.topModal(true)
                        .removeClass('sidebar-opened');
                }
            }, 500, 'sidebar');
        } else {
            Layout.hideRightSidebar();
        }
    }

    static openSidebar() {
        return new Promise(async (res) => {
            if (Layout.isModalOpen()) {
                Layout.topModal(true)
                    .addClass('open-right-sidebar');

                timeout(function () {
                    Layout.topModal(true)
                        .addClass('sidebar-opened');
                    res(true);
                }, 500, 'sidebar');
            } else {
                Layout.showRightSidebar();
                res(true);
            }
        });
    }

    static closeModals() {
        $(".custom-modal:visible").each(function () {
            $(this).data('modal').close();
        });
    }

    static topModal(element = false) {

        let $modal = $(".custom-modal:visible:last");
        if (element)
            return $modal.length ? $modal : false;

        return $modal.length ? $modal.data('modal') : false;
    }

    static closeTopModal(data) {
        let $modal = Layout.topModal();
        if ($modal)
            $modal.close(data);
    }

    static topSideModal(element = false) {

        let $modal = $(".side-modal:visible:last");
        if (element)
            return $modal.length ? $modal : false;

        return $modal.length ? $modal.data('modal') : false;
    }

    static closeTopSideModal(data) {
        let $modal = Layout.topSideModal();
        if ($modal)
            $modal.close(data, false);
    }

    static async modalContent(content, options = {}) {
        return new Promise((resolve) => {
            if (options.afterOpen) {
                let afterOpen = options.afterOpen;
                options.afterOpen = function () {
                    afterOpen();
                    resolve(true);
                };
            }
            $.modal($.extend({
                content,
                afterOpen: function () {
                    resolve(true);
                }
            }, options));
        });
    }

    /**
     * Função futura para quando quisermos converter json em html
     * @param data
     * @return string
     */
    static responseToHtml(data) {
        return JSON.stringify(data);
    }

    static loadTelInput() {
        return new Promise(resolve => {
            if (Layout.flags.loadedIntlTelInput) {
                resolve(true);
            } else {
                window.intlTelInputGlobals.loadUtils("/js/vendor.intlTelInput-utils.min.js").then(() => {
                    Layout.flags.loadedIntlTelInput = true;
                    resolve(true);
                });
            }
        });
    }

    static zoomeable($el) {
        if ($($el).hasClass('bindEvents'))
            return;
        $($el).off('click.zoomeable').on('click.zoomeable', function (ev) {
            let extension = $(this).data('extension');
            if (!(extension)) {
                extension = $(this).attr('href').split('.').pop().toLowerCase();
            }
            // se for vazio tenta descobrir pelo href?

            if (Layout.zoomeableExtensions.indexOf(extension) >= 0 || Layout.googleDocsExtensions.indexOf(extension) >= 0) {
                ev.preventDefault();

                let data = [];
                let curIndex = 0;
                let src = $(this).attr('href');
                let idx = 0;
                if ($(this).attr('rel')) {
                    $('a[rel="' + $(this).attr('rel') + '"]').each(function () {
                        let subExtension = $(this).data('extension');
                        if (!(subExtension)) {
                            subExtension = $(this).attr('href').split('.').pop().toLowerCase();
                        }
                        // se for vazio tenta descobrir pelo href?

                        if (Layout.zoomeableExtensions.indexOf(subExtension) >= 0 || Layout.googleDocsExtensions.indexOf(subExtension) >= 0) {
                            data.push({
                                src: $(this).attr('href')
                            });
                            if ($(this).attr('href') === src) {
                                curIndex = idx;
                            }
                            idx++;
                        }
                    });
                } else {
                    data.push({
                        src: src
                    });
                }

                /*if (Layout.googleDocsExtensions.indexOf(extension)) {
                    data.type = 'iframe';
                } else if (extension === 'mp4') {
                    data.type = 'iframe';
                } else {
                    data.type = 'image';
                }*/


                Fancybox.show(data, {
                    startIndex: curIndex,
                    Hash: false,
                    Images: {
                        maxScale: 3,

                        Panzoom: {
                            maxScale: 3
                        },
                    },
                    Toolbar: {
                        display: {
                            left: ["infobar"],
                            middle: [
                                "zoomIn",
                                "zoomOut",
                                "toggle1to1",
                                "rotateCCW",
                                "rotateCW",
                                "flipX",
                                "flipY",
                            ],
                            right: ["download", "slideshow", "thumbs", "close"],
                        },
                    },

                }, curIndex);
            }
        })
    }

    static datepicker($el, options) {
        if (options.month) {
            options.plugins = [
                new monthSelectPlugin({
                    shorthand: true,
                    dateFormat: "Y-m",
                    altFormat: "F Y",
                    altInput: true,
                    theme: "light"
                })
            ];
        }

        flatpickr($el, extend({
            altInput: true,
            enableTime: false,
            onChange: function (selectedDates, dateStr, instance) {
                $($el).trigger('change');
            },
            altFormat: Internationalization.getDatePickerPattern(true),
            locale: window.ISO2_LOCALE
        }, options));

        if ($($el).is('[readonly]')) {
            $($el).next('.datepicker').prop('disabled', true);
        }

    }

    static ajaxTooltip($el, $container, defaultOptions = null) {
        if (typeof $el === 'undefined') {
            $el = '[data-ajax-tooltip]';
        }
        $($el, $container).each(function () {
            let url = $(this).data('ajax-tooltip');
            let options = defaultOptions ? $.extend(defaultOptions, $(this).data()) : $(this).data();

            Layout.tooltip(this, $container, $.extend({
                content: `<div class="padding-1"><div class="preloader-wrapper big active ">
                    <div class="spinner-layer spinner-blue-only">
                      <div class="circle-clipper left">
                        <div class="circle"></div>
                      </div><div class="gap-patch">
                        <div class="circle"></div>
                      </div><div class="circle-clipper right">
                        <div class="circle"></div>
                      </div>
                    </div>
                  </div></div>`,
                flipOnUpdate: true,
                interactive: true,
                placement: 'auto',
                onTrigger(instance, ev) {
                    if ($(ev.target).is('button') || $(ev.target).parents('button').length) {
                        instance.disable();
                        setTimeout(function () {
                            instance.enable();
                        });
                    }
                },
                onCreate(instance) {
                    // Setup our own custom state properties
                    instance._isFetching = false;
                    instance._content = null;

                    if (options.afterCreate) {
                        options.afterCreate(instance);
                    }

                },
                onShow: async function (instance) {
                    if (instance._isFetching || instance._content) {
                        return;
                    }

                    instance._isFetching = true;
                    let data;
                    if (options.data) {
                        data = await Http.post(url, options.data);
                    } else {
                        data = await Http.get(url);
                    }
                    instance._content = data.data;
                    instance.setContent(data.data);
                    instance._isFetching = false;


                    if (options.afterShow) {
                        options.afterShow(instance);
                    }
                }
            }, options))
        });
    }

    static userTooltip($el, $container) {
        if (typeof $el === 'undefined') {
            $el = '[data-user]';
        }
        $($el, $container).each(function () {
            $(this).data({
                'ajax-tooltip': '/user/info/' + $(this).data('user'),
                'trigger': 'click',
                'boundary': 'viewport',
                'append-to': 'body',
                'maxWidth': 'none',
            });

            Layout.ajaxTooltip(this);
        });
    }

    static assignmentsTooltip($el, $container) {
        if (typeof $el === 'undefined') {
            $el = '[data-assignments]';
        }
        $($el, $container).each(function () {
            $(this).data({
                'ajax-tooltip': '/indicator/' + $(this).data('assignments').replace(',', '/assignments/'),
                'trigger': 'click',
                'boundary': 'viewport',
                'append-to': 'body'
            });

            Layout.ajaxTooltip(this);
        });
    }

    static linksTooltip($el, $container) {
        if (typeof $el === 'undefined') {
            $el = '[data-links]';
        }
        $($el, $container).each(function () {
            let links = '';

            $.each($(this).data('links'), function (link, label) {
                links += `<li><a href="${link}" class="navigate">${label}</a></li>`;
            });

            $(this).data({
                'content': `<ul>` + links + '</ul>',
                'trigger': 'click',
                'boundary': 'viewport',
                'append-to': 'body'
            });

            Layout.tooltip(this);
        });
    }

    static companyTooltip($el, $container) {
        if (typeof $el === 'undefined') {
            $el = '[data-company]';
        }
        $($el, $container).each(function () {
            $(this).data({
                'ajax-tooltip': '/company/info/' + $(this).data('company'),
                'trigger': 'click',
                'boundary': 'viewport',
                'append-to': 'body'
            });

            Layout.ajaxTooltip(this);
        });
    }

    static roleTooltip($el, $container) {
        if (typeof $el === 'undefined') {
            $el = '[data-role]';
        }
        $($el, $container).each(function () {
            $(this).data({
                'ajax-tooltip': '/admin/role/' + $(this).data('role') + '/info',
                'trigger': 'click',
                'boundary': 'viewport',
                'append-to': 'body'
            });

            Layout.ajaxTooltip(this);
        });
    }

    static unitsTooltip($el, $container) {
        if (typeof $el === 'undefined') {
            $el = '[data-units]';
        }
        $($el, $container).each(function () {
            if ($(this).data('units') && $(this).data('units') !== '') {
                $(this).data({
                    'ajax-tooltip': '/unit/list',
                    'interactive': true,
                    'data': {
                        units: $(this).data('units')
                    },
                    'theme': 'no-padding',
                    'trigger': 'click',
                    'boundary': 'viewport',
                    'append-to': 'body'
                });

                Layout.ajaxTooltip(this);
            }
        });
    }

    static unitTooltip($el, $container) {
        if (typeof $el === 'undefined') {
            $el = '[data-unit]';
        }
        $($el, $container).each(function () {
            if ($(this).data('unit') && $(this).data('unit') !== '') {
                $(this).data({
                    'ajax-tooltip': '/unit/' + $(this).data('unit') + '/tree?response=' + ($(this).data('response') ? 1 : 0),
                    'interactive': $(this).data('response') == 1,
                    'trigger': 'click',
                    'boundary': 'viewport',
                    'append-to': 'body'
                });

                Layout.ajaxTooltip(this);
            }
        });
    }


    static moduleTooltip($el, $container) {
        if (typeof $el === 'undefined') {
            $el = '[data-module]';
        }
        $($el, $container).each(function () {
            if ($(this).data('module') && $(this).data('module') !== '') {
                $(this).data({
                    'ajax-tooltip': '/module/' + $(this).data('module') + '/tooltip',
                    'interactive': false,
                    //'trigger': 'click',
                    'theme': 'light',
                    'boundary': 'viewport',
                    'append-to': 'body'
                });

                Layout.ajaxTooltip(this);
            }
        });
    }

    static indicatorsTooltip($el, $container) {
        if (typeof $el === 'undefined') {
            $el = '[data-indicators]';
        }
        $($el, $container).each(function () {
            $(this).data({
                'ajax-tooltip': '/indicator/tooltip-list',
                'interactive': true,
                'data': {
                    indicators: $(this).data('indicators')
                },
                'trigger': 'click',
                'boundary': 'viewport',
                'append-to': 'body'
            });

            Layout.ajaxTooltip(this);
        });
    }

    static destroyTooltip($el) {
        $($el).each(function () {
            if (this._tippy) {
                this._tippy.destroy();

                $(this).data('tooltipLoaded', false);
            }
        });
    }

    static tooltip($el, $container, options) {
        if (typeof $el === 'undefined') {
            $el = '[data-tooltip]';
        }
        let $default, $data;
        $($el, $container).each(function () {
            if ($(this).data('tooltipLoaded')) {
                let content = '';
                if ($(this).data('tooltip') && $(this).data('tooltip') !== '') {
                    content = $(this).data('tooltip');
                } else if ($(this).attr('title')) {
                    content = $(this).attr('title');
                } else if ($(this).data('content')) {
                    content = $(this).data('content');
                } else if (options && options.content) {
                    content = options.content;
                }

                if (content !== undefined && content !== '' && this._tippy) {
                    this._tippy.setContent(content);
                }

                return;
            }
            $default = {};
            $data = $(this).data();
            $data.allowHTML = true;
            if ($data.position) {
                $data.placement = $data.position;
            }

            let $content = '';

            if ($content === '' && $data.tooltip && $data.tooltip !== '') {
                $content = $data.tooltip;
            }

            if ($content === '' && $(this).attr('title')) {
                $content = $(this).attr('title');
                $(this).removeAttr('title');
            }

            if ($content === '' && $(this).attr('alt')) {
                console.warn('Deprecated tooltip used with attribute alt, change to data-tooltip or title: ' + $(this).attr('alt'), this);
                $content = $(this).attr('alt');
            }

            $default = $.extend($default, {content: $content}, options, $data);

            if ($default.appendTo && $default.appendTo === 'body') {
                $default.appendTo = () => document.body;
            }

            if ($default.content && $default.content !== '') {
                $(this).data('tooltipLoaded', true);
                const tip = tippy(this, $default);

                if (options && options.autoShow) {

                    tip.show();
                }
            }


        })
    }

    static form(data, $element, callback) {
        let fb = new FormBuilder(data);
        $element.append(fb.generate());
        fb.init();

        if (data.Value !== null && typeof data.Value === 'object') {
            fb.setValues(data.Value);
        }

        if (typeof callback === 'function') {
            callback(data, $element, fb);
        }
        return fb;
    }

    static setActiveMenu(menuItem) {
        $("#main-menu .menu-item.active, #main-menu .extra-menu-item.active").removeClass('active');
        if (Layout.menus[menuItem]) {
            Layout.menus[menuItem].addClass('active');
            if (menuItem.indexOf('profile.') >= 0) {
                $("#main-menu .user-profile").click();
            }
        }
    }


    static closeMenu() {
        $("body").data('closed', true).addClass('closed-menu').trigger('toggled-menu');

        $("#main-menu .on-profile-menu, #main-menu .on-tools-menu").addClass('hidden');
        $("#main-menu .on-main-menu").removeClass('hidden').addClass('animated fadeIn ');

        Layout.resizeCharts();


    }

    static showMenu() {
        $("body").data('closed', false).removeClass('closed-menu').removeClass('will-close').trigger('toggled-menu');
        Layout.showingMenu = true;
        setTimeout(function () {
            Layout.showingMenu = false;
        }, 300);
    }

    static setCompany(company_id) {
        window.location = '/' + company_id;
        //window.location = '/company/change/' + company_id;
    }

    static setTitle(title) {
        if (Layout.canChangeTitle)
            document.title = title.replace('&gt;', '>').replace('&amp;', '&');
    }

    static blockUI(options = {}) {
        if (typeof options === 'string') {
            options = {message: options};
        }

        $.blockUI(extend({
            css: {
                backgroundColor: Layout.darkMode ? '#1e272b' : "#fff",
                padding: 30,
                borderRadius: 10,
                cursor: 'default',
                color: Layout.darkMode ? '#7292a0' : "#7292a0",
            },
            overlayCSS: {
                backgroundColor: Layout.darkMode ? '#181f23' : "#fff"

            }
        }, options))
    }

    static unblockUI() {
        $.unblockUI();
    }

    static textareaAutoResize = function ($textarea) {
        // Wrap if native element
        if ($textarea instanceof Element) {
            $textarea = $($textarea);
        }

        if (!$textarea.length) {
            console.error('No textarea element found');
            return;
        }

        // Textarea Auto Resize
        let hiddenDiv = $('.hiddendiv').first();
        if (!hiddenDiv.length) {
            hiddenDiv = $('<div class="hiddendiv common" style="display: block !important;"></div>');
            $('body').append(hiddenDiv);
        }
        hiddenDiv.css('border-width', $textarea.css('border-width'));

        // Set font properties of hiddenDiv
        let fontFamily = $textarea.css('font-family');
        let fontSize = $textarea.css('font-size');
        let lineHeight = $textarea.css('line-height');

        // Firefox can't handle padding shorthand.
        let paddingTop = $textarea.css('padding-top');
        let paddingRight = $textarea.css('padding-right');
        let paddingBottom = $textarea.css('padding-bottom');
        let paddingLeft = $textarea.css('padding-left');

        if (fontSize) {
            hiddenDiv.css('font-size', fontSize);
        }
        if (fontFamily) {
            hiddenDiv.css('font-family', fontFamily);
        }
        if (lineHeight) {
            hiddenDiv.css('line-height', lineHeight);
        }
        if (paddingTop) {
            hiddenDiv.css('padding-top', paddingTop);
        }
        if (paddingRight) {
            hiddenDiv.css('padding-right', paddingRight);
        }
        if (paddingBottom) {
            hiddenDiv.css('padding-bottom', paddingBottom);
        }
        if (paddingLeft) {
            hiddenDiv.css('padding-left', paddingLeft);
        }

        // Set original-height, if none
        if (!$textarea.data('original-height')) {
            $textarea.data('original-height', $textarea.height());
        }

        if ($textarea.attr('wrap') === 'off') {
            hiddenDiv.css('overflow-wrap', 'normal').css('white-space', 'pre');
        }

        let $value = $textarea[0].value;
        if ($value.length === 0 && $textarea.attr('placeholder')) {
            $value = $textarea.attr('placeholder');
        }
        hiddenDiv.text($value + '\n');
        let content = hiddenDiv.html().replace(/\n/g, '<br>');
        hiddenDiv.html(content);

        // When textarea is hidden, width goes crazy.
        // Approximate with half of window size

        if ($textarea[0].offsetWidth > 0 && $textarea[0].offsetHeight > 0) {
            hiddenDiv.css('width', $textarea.outerWidth() + 'px');
        } else {
            hiddenDiv.css('width', window.innerWidth / 2 + 'px');
        }
        /**
         * Resize if the new height is greater than the
         * original height of the textarea
         */
        if ($textarea.data('original-height') <= hiddenDiv.outerHeight()) {
            $textarea.css('height', hiddenDiv.outerHeight() + 'px');
        } else if ($value.length < $textarea.data('previous-length')) {
            /**
             * In case the new height is less than original height, it
             * means the textarea has less text than before
             * So we set the height to the original one
             */
            $textarea.css('height', $textarea.data('original-height') + 'px');
        }
        $textarea.data('previous-length', $value.length);
    }
}

let isCtrlPressed = false;
window.addEventListener('keydown', (event) => {
    if (event.key === 'Control') {
        isCtrlPressed = true;
    }
});
window.addEventListener('keyup', (event) => {
    if (event.key === 'Control') {
        isCtrlPressed = false;
    }
});
